import React from 'react'
import styled from '@emotion/styled'
import { jsx, css } from '@emotion/react'
import StarRatingComponent from 'react-star-rating-component'
import {getGenresFromIds} from '../utils'
import WatchlistButton from './buttons/WatchlistButton'
import { Trans, Link } from 'gatsby-plugin-react-i18next';

const handleClick = e => {
  // In a webview, send this data instead of navigating
  if (window.ReactNativeWebView) {
    e.preventDefault()
    let url = e.currentTarget.href.split('/')
    let slug = url[url.length - 1]
    let title = e.currentTarget.title
    window.ReactNativeWebView.postMessage(JSON.stringify({title, slug}))
  }
}

const MovieCardLarge = props => {
  if (props.skeleton) {
    return (
      <Container className="shadow-sm">
        <ImgContainer>
          <div 
          css={css`
            width: 113.333px;
            height: 150px;
            @media (min-width: 500px) {
              height: 255px;
              width: 170px;
            }`} 
    style={{}} className="bg-light shadow-sm"> </div>
        </ImgContainer>
        <Description>
          <h1 className="bg-light w-100 shadow-sm mb-3" style={{height: 30}}></h1>
          <Rating>
            {/* <Skeleton/>  */}
            <div className="bg-light w-100 shadow-sm" style={{height: 20}}></div>
          </Rating>
          <Meta> 
           <div className="bg-light w-100 shadow-sm" style={{height: 20}}></div>
           <div className="bg-light w-100 shadow-sm mt-2" style={{height: 20}}></div>
          </Meta>
          <p>
            <div className="bg-light w-100 shadow-sm mt-2 mb-4" style={{height: 20}}></div>
          </p>
          <Bottom>
            {/* <div className="bg-light w-100 shadow-sm" style={{height: 15}}></div> */}
          </Bottom>
        </Description>
      </Container>
    )
  }
  const genres = typeof props.movie.movie !== 'undefined' ? getGenresFromIds(props.movie.movie.genres, 3) : null
  const title = props.movie.title.length < 41 
  ? props.movie.title
  : `${props.movie.title.slice(0, 41)}...`

  // Get movie url
  let movie_id;
  if (props.movie.is_streaming){
    try {
      movie_id = props.movie.movie.videos.filter(i => i.type === "movie" && i.taken_down === false)[0].id
    } catch (err){
      console.log(err)
    }
  }
  return (
      <Container className="">
        <Link to={`/t/${props.movie.slug}`} onClick={handleClick} title={props.movie.title} className="text-decoration-none text-body">
          <ImgContainer>
            {/* <img src="https://dummyimage.com/170x225/000/fff" className="w-100 h-100"/> */}
            <img src={  props.movie.poster_thumb 
                      ? props.movie.poster_thumb.url 
                      : props.movie.posterThumb 
                          ? props.movie.posterThumb.url 
                          : ''
                      } className="w-100 h-100"/>
          </ImgContainer>
        </Link>
        <Description>
          <Link to={`/t/${props.movie.slug}`} onClick={handleClick} title={props.movie.title} className="text-decoration-none text-body">
            <Title>{title}</Title>
            {props.movie.total_ratings ?
              <Rating>
                <StarRatingComponent 
                  name="rating" 
                  emptyStarColor={'#bfbfbf'}
                  starCount={5} 
                  value={props.movie.avg_rating || 0} /> 
                  {/* <span className="font-weight-lighter font-italic mb-5">{props.movie.total_ratings}</span> */}
              <RatingNumber>{props.movie.total_ratings ? `(${props.movie.total_ratings})` : ''} </RatingNumber>
              </Rating>
              : ''
            }

            <Meta className="">
              {props.movie.movie && props.movie.movie.runtime ? `${props.movie.movie.runtime}mn - ` : '' }{genres}
            </Meta>
            <Synopsis>{props.movie.synopsis ? props.movie.synopsis.slice(0, 205) : ''}...</Synopsis>
          </Link>
          <Bottom>
            {/* <Link to={`t/${props.movie.slug}`} className="btn btn-light btn-sm mr-2 d-none d-md-inline-block">★ Noter</Link> */}
            {props.movie.is_streaming && 
              <Link to={`/t/${props.movie.slug}`} className="btn btn-dark mr-2 btn-sm"><Trans>Voir ici</Trans></Link>
            }
            { props.watchlist && 
              <WatchlistButton
                inWatchlist={props.movie.in_watchlist}
                movieTranslation={props.movie}
                watchlist={props.watchlist}
                buttonStyle="small"
              />
            }
            {/* <Link to={`t/${props.movie.slug}`} className="btn btn-light btn-sm mr-2 d-none d-md-inline-block">👍</Link>
            <Link to={`t/${props.movie.slug}`} className="btn btn-light btn-sm mr-2 d-none d-md-inline-block">👎</Link> */}
            {/* <Link to={props.movie.slug} className="btn btn-link btn-sm p-0 mr-2">Voir trailer</Link>
            <Link to={`watch/${props.movie.slug}`} className="btn btn-link btn-sm p-0">Voir film</Link> */}
          </Bottom>
        </Description>
      </Container>
  )
}


const Container = styled.div`
  display: flex;
  margin-bottom: 1em;
  /* max-width: 620px; */
  background-color: #FFF;
  /* max-height: 225px; */
  overflow: hidden;

  @media (max-width: 500px) {
    margin: 8px auto;
  }
`
const ImgContainer = styled.div`
  min-width: 170px;
  height: 225px;
  
  @media (max-width: 500px) {
    min-width: 101.999px;
    height: 135px;
  }
`
const Description = styled.div`
  width: 100%;
  margin: 0 0.5em;
  padding: 0.5em;
  display: flex;
  flex-direction: column;
  justify-content: felx-start;
  @media (max-width: 500px) {
    justify-content: flex-start;
    font-size: 1em;
    margin: 0 0.5em;
    padding: 8px 8px 0px 8px;
  }
`
const Title = styled.h5`
  /* font-weight: bold; */
  max-height: 48px;
  overflow: hidden;
  @media (max-width: 500px) {
    font-size: 14.4px;
    margin-bottom: 1.43333px;
  }
`
const Rating = styled.div`
  height: 28px;
  @media (max-width: 500px) {
    font-size: 11.2px;
    margin-top: 0;
    height: 20px;
  }
`
const Meta = styled.div`
  font-size: 11px;
  font-weight: 400;
  font-style: normal;
  max-width: 400px;
  letter-spacing: -.005em;
  color: #666666;

  @media (max-width: 500px) {
    margin-top: 0;
    font-size: 11.2px;
    height: 13.5px;
    overflow: hidden;
  }
`
const Synopsis = styled.div`
  margin-top: 0.5em;
  font-size: 0.9em;
  color: #333;
  @media (max-width: 500px) {
    margin-top: 3.36667px;
    font-size: 11.2px;
    max-height: 50px;
    overflow: hidden;
  }
`
const Bottom = styled.div`
  margin: auto 0 0;
  font-size: 0.9em;
  color: #333;
`
const RatingNumber = styled.span`
  font-size: 15px;
  position: absolute;
  margin-left: 5px;
  color: #666666;

  @media (max-width: 500px) {
    font-size: 10px;
  }
`


export default MovieCardLarge